import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';

import { ExtranetPackages as LegacyPackages } from './Legacy/ExtranetPackages';
import { ExtranetPackages as ModernPackages } from './Modern/ExtranetPackages';

export const PackagesRouter = () => {
  const { hotelLoading, hotelInfo, isLegacy } = useContext(HotelContext);

  if (hotelLoading || !hotelInfo) {
    return null;
  }

  return isLegacy ? <LegacyPackages /> : <ModernPackages />;
};
